var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2298 2.28885C22.5717 1.09698 21.8575 0.877749 20.4034 0.79438C18.9508 0.694028 15.298 0.652344 12.1335 0.652344C8.96288 0.652344 5.30858 0.694028 3.85748 0.792836C2.40637 0.877749 1.69068 1.09544 1.02654 2.28885C0.34875 3.47918 0 5.52944 0 9.13902C0 9.1421 0 9.14365 0 9.14365C0 9.14674 0 9.14828 0 9.14828V9.15137C0 12.7455 0.34875 14.8112 1.02654 15.9892C1.69068 17.1811 2.40486 17.3972 3.85596 17.4975C5.30858 17.584 8.96288 17.635 12.1335 17.635C15.298 17.635 18.9508 17.584 20.4049 17.4991C21.859 17.3987 22.5732 17.1826 23.2313 15.9907C23.9152 14.8128 24.2609 12.747 24.2609 9.15291C24.2609 9.15291 24.2609 9.14828 24.2609 9.14519C24.2609 9.14519 24.2609 9.1421 24.2609 9.14056C24.2609 5.52944 23.9152 3.47918 23.2298 2.28885Z",
    fill: "#242946"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89551 14.3997V4.69531L16.1738 9.54749L8.89551 14.3997Z",
    fill: "#FAFAFA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6288f1495d66b0de47939b9f24efbc49.svg";
export { ForwardRef as ReactComponent };